import * as React from "react";
import { useEffect, useState } from "react";
import Scan, { FaceDescriptors, getI18nMouthDescription } from "./commons/model/Scan";
import sfetch from "./commons/utils/super-fetch";

interface PrintableScanPackageViewerProps {
  scans: Scan[];
  name: string;
  onComplete: () => void;
}

export function PrintableScanPackageViewer({
  scans,
  name,
  onComplete,
}: PrintableScanPackageViewerProps) {
  const [availableScans, setAvailableScans] = useState<Map<string, string>>(new Map());

  useEffect(() => {
    const getAvailableScans = async () => {
      const temporaryImagesCache = new Map<string, any>();
      await Promise.all(
        scans.map(async (scan) => {
          const scanUrl = buildScanHref(scan);
          await sfetch(scanUrl, {
            method: "GET",
          })
            .then(async (response) => {
              temporaryImagesCache.set(scan.uid, URL.createObjectURL(await response.blob()));
            })
            .catch(() => {
              // gsalaun : Keep catch to avoid Promise.all to finish prematurely
            });
        })
      );
      setAvailableScans(temporaryImagesCache);
      onComplete();
    };
    getAvailableScans();
    return () => {};
  }, [scans]);

  // LongTermFix yelkhyari 13/10/20 : get cropped/not cropped photos mechanism is too loose, should be better defined
  //  (example : have a label AVATAR instead FACE_SMILING cropped and get cropped/not cropped based on labels)
  const buildScanHref = (scan: Scan) => {
    if (FaceDescriptors.includes(scan.descriptor)) return `${scan.href}?cropped=false`;
    else return scan.href;
  };

  return (
    <div className="printable-scan-package-viewer">
      <h2>{name}</h2>
      <div className="scan-package-container">
        {scans
          .reverse()
          .filter((scan) => availableScans.has(scan.uid))
          .map((scan) => (
            <div key={scan.uid} className="labelled-photo-container">
              <div className="labelled-photo">
                <img src={availableScans.get(scan.uid)} alt="labelled photo" />
                <label>{i18n[getI18nMouthDescription(scan.descriptor)]}</label>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
